import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AutomationMonitor, FiltersComponent } from 'reg-hub-common';
import { QueueMonitorsRepositoryService } from '../../../services/queue-monitors/queue-monitors-repository.service';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-queue-monitors-filter',
    templateUrl: './queue-monitors-filter.component.html',
    styleUrl: './queue-monitors-filter.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QueueMonitorsFilterComponent extends FiltersComponent<AutomationMonitor> implements OnInit {
  constructor(
    queueMonitorsRepository: QueueMonitorsRepositoryService,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(queueMonitorsRepository, formBuilder, datePipe);
  }
  
  ngOnInit(): void {
    this._filterForm = this.formBuilder.group({
      automationName: [null],
      isFailed: [false],
      isEnabled: [false]
    });
  }
}
